import {ICommAccessTokenRequestParams} from "../models/ICommAccessTokenRequestParams";

class CommunicationAccessTokenRequestParamsBuilder {

    commAccessTokenRequestParams: ICommAccessTokenRequestParams;

    constructor() {
        this.commAccessTokenRequestParams = {
            appointmentId: null,
            commMode: null,
            commUserId: null,
            commUserType: null,
            endPointId: null,
            roomName: null
        };
    }

    setAppointmentId(appointmentId: number): CommunicationAccessTokenRequestParamsBuilder {
        this.commAccessTokenRequestParams.appointmentId = appointmentId;
        return this;
    }

    setCommMode(commMode: string): CommunicationAccessTokenRequestParamsBuilder {
        this.commAccessTokenRequestParams.commMode = commMode;
        return this;
    }

    setCommUserId(commUserId: number): CommunicationAccessTokenRequestParamsBuilder {
        this.commAccessTokenRequestParams.commUserId = commUserId;
        return this;
    }

    setCommUserType(commUserType: string): CommunicationAccessTokenRequestParamsBuilder {
        this.commAccessTokenRequestParams.commUserType = commUserType;
        return this;
    }


    setEndPointId(endPointId: string): CommunicationAccessTokenRequestParamsBuilder {
        this.commAccessTokenRequestParams.endPointId = endPointId;
        return this;
    }

    setRoomName(roomName: string): CommunicationAccessTokenRequestParamsBuilder {
        this.commAccessTokenRequestParams.roomName = roomName;
        return this;
    }

    build(): ICommAccessTokenRequestParams {
        return this.commAccessTokenRequestParams;
    }
}

export default CommunicationAccessTokenRequestParamsBuilder